import moment from 'moment';
import React from 'react';
import { IFuncionario } from '../../../../@interfaces';

import { Container, NameContainer, UserContainer, Avatar } from './styles';
import aux from '../../../../utils/auxiliar';
import Title from '../../../../components/title';
import Subtitle from '../../../../components/subtitle';
import Text from '../../../../components/text';

interface IProps {
  funcionario: IFuncionario
}

const Card: React.FC<IProps> = ({ funcionario }) => {
  const dtAdmissao = aux.formatRawDateToDate(funcionario.dataAdmissao);
  return (
    <Container>
      <UserContainer>
        <Avatar>
          {<img src={funcionario.avatar ? funcionario.avatar : "assets/user.png"} />}
        </Avatar>
        <NameContainer>
          <Title className='!text-[.875rem] !font-medium'>{funcionario.nome}</Title>
          <Subtitle className='!text-[.75rem] !font-medium  !text-[rgba(38,70,83,.5)]'>{funcionario.empresa}</Subtitle>
        </NameContainer>
      </UserContainer>
      <div className='max-[560px]:w-[140px] ml-4 shrink-0'>
        <Text className='!text-[rgba(0,0,0,.4)] !font-medium !flex !gap-1 ml-3 ' >Data de admissão: <Text className='!text-[rgba(0,0,0,.4)]'>{dtAdmissao}</Text></Text>
      </div>
    </Container>
  )
}

export default Card;